import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#building-clip)",
		children: /* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M2.534 12.5h7.17m-7.17 0V4.435c0-1.068.917-1.935 2.049-1.935h3.073c1.131 0 2.049.867 2.049 1.935v.807M2.534 12.5H1.168m8.537 0V5.242m0 7.258h4.097M9.705 5.242h2.048c1.132 0 2.05.866 2.05 1.935V12.5m0 0h1.365M6.973 5.726H5.266m0 2.58h1.707"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "building-clip",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgBuilding;
